import { inject, Injectable, signal } from '@angular/core';
import { ApiState, RestApiService } from './http/rest-api.service';
import { City } from '../../shared/models/city.model';
import { Eps } from '../../shared/models/eps.model';
import { RestApiV2Service } from './http/rest-api-v2.service';
import { Laboratory } from '../../shared/models/laboratory.model';
import { take } from 'rxjs';
import { Ips } from '../../shared/models/users/ips.model';

@Injectable({
  providedIn: 'root',
})
export class SystemService {
  private restApi = inject(RestApiService);
  private restApiV2 = inject(RestApiV2Service);


  cityList = signal<ApiState<{data: {cities: City[]}}> | null>(null);
  epsList = signal<ApiState<{data: {eps: Eps[]}}> | null>(null);
  laboratoryList = signal<ApiState<{data: {laboratories: Laboratory[]}}> | null>(null);
  laboratoryListV2 = signal<Laboratory[]>([]);
  cityListV2 = signal<City[]>([]);
  ipsList = signal<Ips[]>([]);

  getCityList() {
    this.cityList.set(this.restApi.get<{data: {cities: any[]}}>('city-list'));
  }

  getEpsList() {
    this.epsList.set(this.restApi.get<{data: {eps: any[]}}>('eps-list'));
  }

  getLaboratoryList() {
    this.laboratoryList.set(this.restApi.get<{data: {laboratories: any[]}}>('laboratory-list'));
  }

  getCityListV2() {
    const response = this.restApiV2.get<{data: {cities: City[]}}>('city-list');

    response.request$.pipe(take(1)).subscribe((response) => {
      this.cityListV2.set(response.data.cities);
    });
  }

  getLaboratoryListV2() {
    const response = this.restApiV2.get<{data: {laboratories: Laboratory[]}}>('laboratory-list');

    response.request$.pipe(take(1)).subscribe((response) => {
      this.laboratoryListV2.set(response.data.laboratories);
    });
  }

  getIpsList() {
    const response = this.restApiV2.get<{data: {ips: Ips[]}}>('ips');

    response.request$.pipe(take(1)).subscribe((response) => {
      this.ipsList.set(response.data.ips);
    });
  }
}
